module.exports = __webpack_public_path__ + "809e60d6728ce3d2390f67a4972a63e4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/scarf-stripes-gray.png
// module id = 1380
// module chunks = 0